/* @flow */
import cx from 'classnames';
import React from 'react';

import Button from 'components/Button.jsx';
import ChatActions from 'chat/actions/ChatActions';
import ChatMembers from 'collections/ChatMembers';
import ChatParticipantSearchMixin from 'components/mixins/ChatParticipantSearchMixin';
import ChatStore from 'chat/stores/ChatStore';
import CurrentUser from 'auth/CurrentUser';
import DeprecatedTokenizerTypeahead from 'components/DeprecatedTokenizerTypeahead.jsx';
import Avatar from 'components/Avatar.jsx';
import getMatcher from 'utils/getMatcher';
import GroupStore from 'groups/stores/GroupStore';
import LoadingIndicator from 'components/LoadingIndicator.jsx';
import PotentialChatMember from 'entities/PotentialChatMember';
import ScrollableArea from 'components/ScrollableArea.jsx';
import Text from 'components/Text.jsx';
import RecipientToken from 'chat/components/UniversalComposerRecipientToken.jsx';
import { pushRouterToChatWithMember } from 'lib/ChatRouteHelper';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { showRecent, hideRecent } from 'reducers/recentMessagesModal';

import MessageStarterItem from './MessageStarterItem.jsx';
import styles from './styles/MessageStarter.css';

export const GroupMessageStarter = React.createClass({
  propTypes: {
    groupCode: React.PropTypes.string,
    chatMembersLimit: React.PropTypes.number.isRequired,
    showRecent: React.PropTypes.func.isRequired,
    hideRecent: React.PropTypes.func.isRequired,
    onRequestHide: React.PropTypes.func,
  },

  contextTypes: {
    router: React.PropTypes.object.isRequired,
  },

  mixins: [
    // TODO remove this mixin and convert to ES6 class
    // Only blocker is scrollToBottom load handling
    ChatParticipantSearchMixin,
  ],

  getInitialState() {
    return {
      selectedMembers: [],
    };
  },

  componentDidMount() {
    this.fetchData('');
  },

  // required by ChatParticipantSearchMixin
  _scrollableArea: null,

  getFilter(query: string) {
    const matcher = getMatcher(query);
    return (member: PotentialChatMember) => (
      matcher([
        member.getName(),
        member.getFirstName(),
        member.getLastName(),
        member.getNote(),
        member.getGroupNames(),
      ])
    );
  },

  fetchData(query: string) {
    return ChatActions
      .promisePotentialChatMembers(query)
      .then(() => ChatStore.getEligibleMemberModels());
  },

  handleSelectionChange(selectedMembers: PotentialChatMember[]) {
    this.setState({ selectedMembers });
  },

  createLocalChat(originIds: number[]) {
    const currentMember = ChatMembers.buildChatMember(CurrentUser.getUser());
    const members = [currentMember].concat(this.state.selectedMembers);
    const title = '';

    ChatActions.loadLocal(members, title, originIds);
    ChatActions.resetSelection(); // deselect current chat to focus on local
  },

  startConversation() {
    const { selectedMembers } = this.state;
    const group = this.props.groupCode ? GroupStore.getGroupForCode(this.props.groupCode) : null;

    // if we are starting a 1 to 1 chat:
    if (selectedMembers.length === 1) {
      pushRouterToChatWithMember(this.context.router, this.props.showRecent, this.props.hideRecent, selectedMembers[0], group);
      if (this.props.onRequestHide) {
        this.props.onRequestHide();
      }
      return;
    }

    // if we are starting a group chat:
    // Timeout to prevent multiple dispatches at the same time
    setTimeout(() => {
      // Create chat in whatever group is open at the time
      const [groupCode, originIds] = group ? [group.getCode(), [group.id]] : ['r', []];
      const conversationPath = `/classes/${groupCode}/messages/new`;
      this.createLocalChat(originIds);
      this.context.router.replace(conversationPath);
    }, 0);
  },

  isAtChatMembersLimit() {
    const { selectedMembers } = this.state;
    return selectedMembers.length === this.props.chatMembersLimit;
  },

  isOverChatMembersLimit() {
    const { selectedMembers } = this.state;
    return selectedMembers.length > this.props.chatMembersLimit;
  },


  renderActionButton() {
    return (
      <Button
        disabled={this.state.selectedMembers.length === 0}
        className={styles.actionButton}
        onClick={this.startConversation}>
        Go
      </Button>
    );
  },

  renderInputToken(member: PotentialChatMember) {
    const user = member.getUser();
    return (
      <RecipientToken>
        <Avatar
          text={user.getInitials()}
          colorHex={user.getColor()}
          size="xsmall"
        />
        {member.getName()}
      </RecipientToken>
    );
  },

  renderParticipantRemainingCount() {
    const { selectedMembers } = this.state;
    if (selectedMembers.length === 0) {
      return null;
    }

    const chatMembersLimit = this.props.chatMembersLimit;
    const remainingCount = chatMembersLimit - selectedMembers.length;
    let text = `You can add ${remainingCount} more people`;
    if (this.isOverChatMembersLimit()) {
      text = 'You have exceeded the maximum number of participants';
    } else if (this.isAtChatMembersLimit()) {
      text = 'You have reached the maximum number of participants';
    } else if (remainingCount === 1) {
      text = 'You can add 1 more person';
    }

    return (
      <Text color={this.isOverChatMembersLimit() ? 'lava' : 'koala'} size="xxsmall">
        {text}
      </Text>
    );
  },

  renderMember(member: PotentialChatMember, highlighted: boolean,
    query: string, onSelect: Function) {
    return (
      <li
        onClick={() => onSelect()}
        key={member.id}>
        <MessageStarterItem
          className={cx({
            [styles.highlightedItem]: highlighted,
          })}
          member={member}
          query={query}
          selectable={this.state.selectedMembers.length > 0}
          selected={this.state.selectedMembers.includes(member)}
        />
      </li>
    );
  },

  renderList(items: *[], loading: boolean) {
    return (
      <div>
        {this.renderParticipantRemainingCount()}
        <ScrollableArea
          // required by ChatParticipantSearchMixin
          ref={(c) => (this._scrollableArea = c)}
          className={styles.scrollArea}
          onScroll={event => this.handleScroll(event)}>
          <ul className={styles.results}>
            {items}
          </ul>
          {loading && <div className={styles.loadingIndicatorContainer}><LoadingIndicator /></div>}
        </ScrollableArea>
      </div>
    );
  },

  renderNoResults(query: string) {
    return (
      <li className={styles.noResults} key="noResults">
        <Text color="pitch" size="xsmall" weight="semibold">
          No people found for &quot;{query}&quot;
        </Text>
      </li>
    );
  },

  render() {
    const actionButton = (
      <Button
        data-test-selector="start_group_chat_button"
        disabled={this.state.selectedMembers.length === 0 || this.isOverChatMembersLimit()}
        className={styles.actionButton}
        onClick={this.startConversation}>
        Go
      </Button>
    );

    return (
      <div className={cx(styles.this, this.props.className)}>
        <DeprecatedTokenizerTypeahead
          prompt="To:"
          placeholder="Select or search for people"
          value={this.state.selectedMembers || ''}
          onChange={this.handleSelectionChange}
          dataSource={this.fetchData}
          dataFilterFactory={this.getFilter}
          listRenderer={this.renderList}
          itemRenderer={this.renderMember}
          tokenRenderer={this.renderInputToken}
          noResultsRenderer={this.renderNoResults}
          actionButton={actionButton}
          autoFocus
          inline
        />
      </div>
    );
  },
});


const mapDispatchToProps = (dispatch: Function) =>
  bindActionCreators({
    showRecent,
    hideRecent,
  }, dispatch);

export default connect(null, mapDispatchToProps)(GroupMessageStarter);



// WEBPACK FOOTER //
// ./src/chat/components/GroupMessageStarter.jsx